<span
  class="zn-pill"
  [class.disabled]="disabled()"
  [ngClass]="variantClass()"
>
  {{ label() | abpLocalization }}

  @if (removable()) {
    <button
      type="button"
      class="bi bi-x"
      (click)="removed.emit()"
      [disabled]="disabled()"
    ></button>
  }
</span>